import React from 'react';

const ReadyMixConcrete = () => {
  return (
    <div className="w-full lg:w-[90%] mx-auto px-4 py-10 font-sans text-gray-800">
      {/* Heading */}
      <h1 className="text-2xl md:text-3xl font-bold mb-6">Ready Mix Concrete</h1>

      {/* Subheading + top image */}
      <div className="md:flex md:items-start gap-4 mb-6">
        <div className="flex-1">
          <h2 className="text-xl font-semibold mb-3">
            Ready-mix concrete supplier in Lahore
          </h2>
          <p className="text-base leading-relaxed">
            Among local concrete suppliers, <span className="font-bold">PACIFIC BUILDERS (PVT) LTD</span> offers the best ready-mixed concrete in Islamabad. Choose <span className="font-bold">PACIFIC BUILDERS (PVT) LTD</span> for your project—we guarantee our mixing concrete will meet any and all domestic, industrial, and commercial construction requirements. We aim to exceed our clients’ expectations by delivering superior service on time and within a reasonable budget.
          </p>
        </div>
        <img
          src="/images/ready-mix-concrete-1.jpg"
          alt="Mixing Concrete"
          className="w-full md:w-[400px] h-auto mt-4 md:mt-0 object-cover rounded"
        />
      </div>

      {/* What is a ready mix concrete */}
      <h3 className="text-lg font-semibold mb-2">What is a ready made concrete mix?</h3>
      <p className="mb-4 text-base">
        Ready made concrete mix or ready mix concrete (RMC) refers to a batch of concrete mixed at a central plant. It consists of the following components:
      </p>
      <ul className="list-disc list-inside mb-6 text-base space-y-1">
        <li>Water</li>
        <li>Aggregates such as sand, crushed stone or gravel</li>
        <li>Portland or other cement</li>
        <li>Chemicals and other additives</li>
      </ul>

      {/* Large Image */}
      <div className="mb-6">
        <img
          src="/images/ready-mix-concrete-2.jpg"
          alt="Pouring concrete"
          className="w-full h-auto rounded shadow"
        />
      </div>

      {/* Bottom paragraph */}
      <p className="text-base mb-4">
        What separates <span className="font-bold">PACIFIC BUILDERS (PVT) LTD</span> from the other <strong>concrete mix suppliers</strong> is our specialized mix concrete types, each tailor-made to suit very specific construction needs. Our ready made concrete mixes are the best choice for:
      </p>

      <ul className="list-disc list-inside mb-6 text-base space-y-1">
        <li>High rise buildings</li>
        <li>Marketing plazas</li>
        <li>Warehouses</li>
        <li>Schools</li>
        <li>Bridges</li>
        <li>Mosques</li>
        <li>Industries</li>
        <li>And much more.</li>
      </ul>

      {/* Cheap mix concrete */}
      <h3 className="text-lg font-semibold mb-2">
        Cheap ready mix concrete with all of the quality
      </h3>
      <p className="mb-4 text-base">
        <span className="font-bold">PACIFIC BUILDERS (PVT) LTD</span> prides itself on providing high-quality ready mix concrete at an affordable price. We value our customers above all else and want to ensure you are entirely satisfied with your materials. We strive to improve production standards with our fine-tuned exceptionally durable concrete. The concrete we supply is not just high quality—it’s consistent, setting the highest bar for all your construction needs.
      </p>

      <p className="mb-4 text-base">
        Our staff is <strong>highly qualified, well-trained</strong>, and have years of working experience. We have earned a specialist reputation as a reliable and affordable ready mix concrete delivery company, in addition to on-site supervision assistance. Just like the volumetric mixing plant on-site, we ensure real-time value also via effortlessly delivering and placement of your mix.
      </p>

      <p className="mb-4 text-base">
        Every <span className="font-bold">PACIFIC BUILDERS (PVT) LTD</span> mix concrete plant uses state-of-the-art automation technology to ensure consistency of quality in our concrete mixes. Our quality assurance staff checks each batch of concrete before delivery to confirm that your design or construction mix can provide the right performance for the future. The concrete we export allows structures to withstand storms, winds, and weather, and the success of a construction project relies heavily on the materials used. Therefore, you have a worry only about your concrete mix being too good.
      </p>

      <p className="mb-4 text-base">
        As one of the best <strong>concrete mix suppliers</strong>, <span className="font-bold">PACIFIC BUILDERS (PVT) LTD</span> provides our ready mix concrete at a reasonable rate. We believe in winning our clients’ confidence and lifelong support by being an affordable option for high-quality concerns. From large-scale infrastructure projects to residential construction, our quality and commitment remain constant.
      </p>

      {/* Delivery from PACIFIC BUILDERS (PVT) LTD */}
      <h3 className="text-lg font-semibold mt-8">Delivery from PACIFIC BUILDERS (PVT) LTD</h3>
    </div>
  );
};

export default ReadyMixConcrete;
